import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const token = getCookie("bb_metaverse_token");


const InviteUser = (props) => {

  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [open, setOpen] = React.useState(false)
  const [inviteUser, setInviteUser] = React.useState({})
  const [accessList, setAccessList] = React.useState([])
  const [accessGroup, setAccessGroup] = React.useState([])
  const [access, setAccess] = React.useState([])
  // State for approval dialog
  const [approveDialogOpen, setApproveDialogOpen] = React.useState(false);
  const [approveDialogUserId, setApproveDialogUserId] = React.useState(null);
  const [approveDialogValues, setApproveDialogValues] = React.useState({
    access: null,
    access_group: [],
    project_access_list: null
  });
  const [columns] = React.useState([
    { title: 'Name', field: 'name', render: rowData => <span>{rowData.first_name + " " + rowData.last_name}</span> },
    { title: 'Email', field: 'email' },
    { title: 'Status', field: 'status', lookup: { 0: 'Pending', 1: 'Approved', 2: 'Rejected' } }
  ])
  const [disabled, setDisabled] = React.useState(false)


  function getData() {
    return new Promise((resolve, reject) => {
      Service.get(props.getAPI, {
        headers: {
          Authorization: "Token " + token,
        },
      }).then(res => resolve(res.data)).catch(error => reject(error))
    })
  }

  function getAccessList() {
    return new Promise((resolve, reject) => {
      Service.get(`/api/projects/access/list/get_project_access_list/`, {
        headers: {
          Authorization: "Token " + token,
        },
      }).then(res => resolve(res.data)).catch(error => reject(error))
    })
  }

  function getAccessGroup() {
    return new Promise((resolve, reject) => {
      Service.get(`/api/access/group/link/get_group_level_project_assess/?project_id=${props.project.id}`, {
        headers: {
          Authorization: "Token " + token,
        },
      }).then(res => resolve(res.data)).catch(error => reject(error))
    })
  }

  function getAccess(id) {
    return new Promise((resolve, reject) => {
      Service.get(`/api/access/management/get_access_data/?access_group_id=${id}`, {
        headers: {
          Authorization: "Token " + token,
        },
      }).then(res => resolve(res.data)).catch(error => reject(error))
    })
  }

  function postInvite() {
    setDisabled(true)
    const email = inviteUser.email ? inviteUser.email.trim() : ''
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    const projectAccessListId = inviteUser.project_access_list?.id
    const accessGroupIds = inviteUser.access_group?.length
      ? inviteUser.access_group.map((group) => group.id).filter(Boolean)
      : null
    if (!email || !projectAccessListId  || !inviteUser.start_date || !inviteUser.end_date) {
      enqueueSnackbar('Please fill all the required fields!', {
        variant: 'warning'
      });
      setDisabled(false)

      return
    } else if (!isValidEmail) {
      enqueueSnackbar('Please enter a valid email!', {
        variant: 'warning'
      });
      setDisabled(false)

      return
    } else {
      Service.post('/api/project/user/invite/user_invite_request/', {
        headers: {
          Authorization: "Token " + token,
        },
        data: {
          'email': email,
          'project': props.project.id,
          'access_parameter': {
            'start_date': inviteUser.start_date ? inviteUser.start_date.format('YYYY-MM-DD') : null,
            'end_date': inviteUser.end_date ? inviteUser.end_date.format('YYYY-MM-DD') : null,
            'project_access_list': projectAccessListId,
            'access_group': accessGroupIds,
          }
        }
      })
        .then(res => {
          setLoading(true)
          getData().then(data => setData(data)).catch(error => console.log(error))
          enqueueSnackbar('User invited successfully!', {
            variant: 'success'
          });
          setOpen(false)
          setLoading(false)
          setDisabled(false)
        })
        .catch(error => {
          console.log(error)
          setDisabled(false)

          if (error.status === 406) {
            enqueueSnackbar(error.data.message, {
              variant: 'warning'
            });
            return
          }
          enqueueSnackbar('Something went wrong!', {
            variant: 'error'
          });
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    Promise.all([getData(), getAccessList(), getAccessGroup() ]).then((data) => {
      setData(data[0]);
      setAccessList(data[1]);
      setAccessGroup(data[2].access.concat(data[2].no_access));
      setLoading(false);
    }).catch(error => {
      enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      });
      console.log(error);
      setLoading(false);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function approveRejectUser(userId, status) {
    Service.patch(`/api/project/user/invite/reject_user_request_or_invite/`, {
      headers: {
        Authorization: "Token " + token,
      },
      data: {
        'invite_id': userId,
      }
    })
      .then(res => {
        enqueueSnackbar('User status updated successfully!', {
          variant: 'success'
        });
        getData().then(data => setData(data)).catch(error => console.log(error))
      })
      .catch(error => {
        console.log(error)
        enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });
  }

  function handleApproveDialogSubmit() {
    if (!approveDialogValues.project_access_list || !approveDialogValues.access || approveDialogValues.access_group.length === 0) {
      enqueueSnackbar('Please select all required fields!', { variant: 'warning' });
      return;
    }
    Service.post(`/api/project/user/invite/approve_user_invite/`, {
      headers: {
        Authorization: "Token " + token,
      },
      data: {
        'invite_id': approveDialogUserId,
        'access_parameter': {
          'project_access_list': approveDialogValues.project_access_list.id,
          'access_group': approveDialogValues.access_group.map(g => g.id),
          'access': approveDialogValues.access.map(a => a.id)
        }
      }
    })
      .then(res => {
        enqueueSnackbar('User status updated successfully!', { variant: 'success' });
        getData().then(data => setData(data)).catch(error => console.log(error));
        setApproveDialogOpen(false);
        setApproveDialogUserId(null);
        setApproveDialogValues({ access: null, access_group: [], project_access_list: null });
      })
      .catch(error => {
        console.log(error);
        enqueueSnackbar('Something went wrong!', { variant: 'error' });
      });
  }

  return (
    <div>
      {loading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'><CircularProgress /></Box> :
        <div>
          <TableContainer component={Paper}>
            <Box width='100%' display='flex' justifyContent='space-between' alignItems='center' padding={2}>
              <Typography variant='h6' fontWeight='bold'>
                {props.title}
              </Typography>
              {props.isInviteUser ?
                <IconButton color='primary' size='small' onClick={() => setOpen(true)}>
                  <AddIcon />
                </IconButton> : null}
            </Box>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.field} align={column.align}>
                      {column.title}
                    </TableCell>
                  ))}
                  {props.isApproveUser ?
                    <TableCell>Action</TableCell> : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {columns.map((column) => (
                      <TableCell key={column.field} align={column.align}>
                        {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                      </TableCell>
                    ))}
                    {props.isApproveUser ?
                      <TableCell sx={{ display: 'flex', flexDirection: 'row' }}>
                        <Tooltip title="Approve">
                          <IconButton onClick={() => approveRejectUser(row.id, 1)}>
                            <CheckIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Reject">
                          <IconButton onClick={() => approveRejectUser(row.id, 2)}>
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell> : null}
                    {/* Approval Dialog with dropdowns */}
                    <Dialog open={approveDialogOpen} onClose={() => setApproveDialogOpen(false)} fullWidth maxWidth='xs'>
                      <DialogTitle>Approve User Request</DialogTitle>
                      <DialogContent sx={{ width: '100%' }}>
                        <Box marginTop={1}>
                          <Autocomplete
                            value={approveDialogValues.project_access_list}
                            onChange={(event, newValue) => setApproveDialogValues({ ...approveDialogValues, project_access_list: newValue })}
                            options={accessList}
                            getOptionLabel={(option) => option.name}
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label="Access List" />}
                          />
                        </Box>
                        <Box marginTop={1}>
                          <Autocomplete

                            value={approveDialogValues.access_group}
                            onChange={(event, newValue) => setApproveDialogValues({ ...approveDialogValues, access_group: newValue })}
                            options={accessGroup}
                            getOptionLabel={(option) => option.name}
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label="Access Group" />}
                          />
                        </Box>
                        <Box marginTop={1}>
                          <Autocomplete

                            value={approveDialogValues.access}
                            onChange={(event, newValue) => setApproveDialogValues({ ...approveDialogValues, access: newValue })}
                            options={access}
                            getOptionLabel={(option) => option.name}
                            sx={{ width: '100%' }}
                            renderInput={(params) => <TextField {...params} label="Access" />}
                          />
                        </Box>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => { setApproveDialogOpen(false); setApproveDialogUserId(null); setApproveDialogValues({ access: null, access_group: [], project_access_list: null }); }} color="primary" size='small' variant='contained'>
                          Cancel
                        </Button>
                        <Button onClick={handleApproveDialogSubmit} color="primary">
                          Approve
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth='xs'>
            <DialogTitle>
              Invite User
            </DialogTitle>
            <DialogContent sx={{ width: '100%' }}>
              <Box marginTop={1}>
                <TextField
                  value={inviteUser.email || ''}
                  onChange={(event) => setInviteUser({ ...inviteUser, email: event.target.value })}
                  label="Email"
                  type="email"
                  autoComplete="email"
                  fullWidth
                />
              </Box>
              <Box marginTop={1} >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    variant='outlined'
                    margin="normal"
                    format='DD/MM/YYYY'
                    value={inviteUser.start_date}
                    onChange={(newValue) => setInviteUser({ ...inviteUser, start_date: newValue })}
                    clearable
                    sx={{ width: '100%' }}
                    fullWidth
                    KeyboardButtonProps={{
                      'aria-label': 'Start Date',
                    }}
                    label='Start Date'
                  />
                </LocalizationProvider >
              </Box>
              <Box marginTop={1}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    variant='outlined'
                    margin="normal"
                    format='DD/MM/YYYY'
                    value={inviteUser.end_date}
                    minDate={inviteUser.start_date}
                    onChange={(newValue) => setInviteUser({ ...inviteUser, end_date: newValue })}
                    clearable
                    sx={{ width: '100%' }}
                    fullWidth
                    KeyboardButtonProps={{
                      'aria-label': 'End Date',
                    }}
                    label='End Date'
                  />
                </LocalizationProvider >
              </Box>
              <Box marginTop={1}>
                <Autocomplete
                  value={inviteUser.project_access_list}
                  onChange={(event, newValue) => setInviteUser({ ...inviteUser, project_access_list: newValue })}
                  options={accessList}
                  getOptionLabel={(option) => option.name}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Access List" />}
                />
              </Box>
              <Box marginTop={1}>
                <Autocomplete
                  multiple
                  value={inviteUser.access_group}
                  onChange={(event, newValue) => {setInviteUser({ ...inviteUser, access_group: newValue }); getAccess(newValue.length > 0 ? newValue[0].id : null).then(data => setAccess(data)).catch(error => console.log(error))}}
                  options={accessGroup}
                  getOptionLabel={(option) => option.name}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Access Group" />}
                />
              </Box>
              <Box marginTop={1}>
                <Autocomplete
                  multiple
                  value={inviteUser.access}
                  onChange={(event, newValue) => setInviteUser({ ...inviteUser, access: newValue })}
                  options={access}
                  getOptionLabel={(option) => option.name}
                  sx={{ width: '100%' }}
                  renderInput={(params) => <TextField {...params} label="Access" />}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { setOpen(false); setInviteUser({}); }} color="primary" size='small' variant='contained'>
                Cancel
              </Button>
              <Button onClick={() => { postInvite() }} disabled={disabled} color="primary">
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      }
    </div>
  )
}

export default InviteUser